import { render, staticRenderFns } from "./vendor-list-items.vue?vue&type=template&id=021a9324"
import script from "./vendor-list-items.vue?vue&type=script&lang=js"
export * from "./vendor-list-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports